
import { Vue, Component, Prop } from 'vue-property-decorator';
import NavigationIcon from '@/components/common/NavigationIcon.vue';
import Badge from '@/components/common/Badge.vue';
import InnerComponent from '@/entities/InnerComponent';

@Component({
	components: {
		NavigationIcon,
		Badge,
	},
})
export default class SidebarItem extends Vue {
	@Prop({ type: String, required: true }) readonly icon!: string;
	@Prop({ type: String, required: true }) readonly title!: string;
	@Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
	@Prop({ type: Boolean, default: false }) readonly child!: boolean;
	@Prop({ type: Object, default: undefined })
	readonly innerComponent!: InnerComponent;

	get titleClasses(): Record<string, boolean> {
		return {
			// ["font-bold"]: !this.child,
		};
	}

	get containerClasses(): Record<string, boolean> {
		return {
			['opacity-50']: this.disabled,
			['pl-12']: this.child,
			['pl-6']: !this.child,
		};
	}
}
